import { asyncComponent } from '@datenpate/after';

export default [
  {
    path: '/:slug*',
    component: asyncComponent({
      loader: () => import(/* webpackChunkName: "formlabs" */ './Page'),
      chunkName: 'formlabs'
    })
  }
];
